module.exports = __webpack_public_path__ + "static/media/Rectangle.29c4eb9f.png";